import Image from 'next/legacy/image';

import { H2, H3, H4, H5 } from '@common/headline';

import HeroImage from '@public/img/how-it-works/our-programme-hero.png';

export const OurProgramme = (): JSX.Element => (
  <div className="relative bg-salmon px-3 pb-[416px] pt-16 md:px-[40px] lg:px-[60px] lg:py-32">
    <div className="lg:container lg:m-auto">
      <div className="flex flex-col lg:max-w-[645px]">
        <div className="z-10 mb-[50px] lg:mb-[100px]">
          <div className="mb-4 text-center lg:mb-6 lg:text-left">
            <H3>
              <span className="text-blue">
                Our programme has been clinically proven to help{' '}
                <span className="text-mono-white">9/10 people lose weight</span>
                .
              </span>
            </H3>
          </div>
          <div className="hidden lg:block">
            <H4>
              <span className="text-blue">
                So, there&apos;s a good chance it will work for you too. Weight
                loss is never easy, but we&apos;ve built a programme that gives
                you the right advice, support, and tools to succeed.
              </span>
            </H4>
          </div>
          <div className="text-center lg:hidden">
            <H5>
              <span className="text-blue">
                So, there&apos;s a good chance it will work for you too. Weight
                loss is never easy, but we&apos;ve built a programme that gives
                you the right advice, support, and tools to succeed.
              </span>
            </H5>
          </div>
        </div>
        <div className="z-10 flex flex-col items-center justify-center lg:flex-row">
          <div className="flex flex-col items-center justify-center border-b-[1px] border-grey pb-6 lg:flex-1 lg:border-b-0 lg:border-r-[1px] lg:pb-0 lg:pr-[50px]">
            <div className="mb-1">
              <H2>
                <span className="text-mono-white">15lb</span>
              </H2>
            </div>
            <span className="text-center text-blue">
              <H4>Lost in twelve months, on average</H4>
            </span>
          </div>
          <div className="flex flex-col items-center justify-center pt-6 lg:flex-1 lg:pl-[50px] lg:pt-0">
            <div className="mb-1">
              <H2>
                <span className="text-mono-white">40%</span>
              </H2>
            </div>
            <span className="text-center text-blue">
              <H4>saw a reduction in blood sugar levels</H4>
            </span>
          </div>
        </div>
      </div>
    </div>
    <Image
      src={HeroImage}
      layout="fill"
      objectFit="contain"
      objectPosition="right bottom"
      alt="Woman smiling"
    />
  </div>
);
